<template>
   <span>

       <div @click="show = (show==true?false:true)">{{this.$getDictName(cateVal,vval)}}</div>

       <div v-if="show">{{this.$getDictdes(cateVal,vval)}}</div>

       <div v-if="show">
           <dictname category="haiwaishuoming_cesuan" :v="vval" />
       </div>

   </span>
</template>
<script>
    export default {
        props: ["category","v"],
        computed: {
            cateVal: function () {
                if(!this.category){
                    return null;
                }
                return this.category;
            },
            vval:function () {
                return this.v;
            }
        },
        data(){
            return{
                show:false,


            }
        }
    }
</script>
